/**
 * GNey's access card (server repo docs/integration-mcp-configure-access-proposal.md §13.7, ruling D8):
 * GNey proposes a change to who can open a module, run an activity, or see a field, column, listing,
 * print template or action, and only the user's Approve applies it. The card rides pendingActions[]
 * with type "access" and commits through Confirmations[] with no model, so it must show every change
 * and warning before Approve is possible.
 */

export const ACCESS_CARD_TYPE = "access";

export function isAccessCard(pa) {
  return !!pa && pa.type === ACCESS_CARD_TYPE;
}

/**
 * A change's item in words: "activities.Approve" → "Approve", "fields.Items.columns.Unit Cost" →
 * "Items › Unit Cost", "listings.My Jobs.filters" → "My Jobs listing filter".
 */
export function accessItemLabel(item) {
  const text = String(item || "");
  const dot = text.indexOf(".");
  const section = dot < 0 ? text : text.slice(0, dot);
  const rest = dot < 0 ? "" : text.slice(dot + 1);
  switch (section) {
    case "module":
      return "Opening the module";
    case "activities":
      return rest;
    case "fields":
      return rest.replace(".columns.", " › ");
    case "listings":
      if (!rest) return "Listings";
      return rest.endsWith(".filters") ? `${rest.slice(0, -".filters".length)} listing filter` : `${rest} listing`;
    case "documents":
      return `${rest} (print template)`;
    case "actions":
      return `${rest} (action)`;
    default:
      return text;
  }
}

/** One row per change, in the order the server listed them. */
export function accessChangeRows(card) {
  const changes = card && Array.isArray(card.changes) ? card.changes : [];
  return changes.map((c) => ({
    label: accessItemLabel(c && c.item),
    before: c && c.before != null ? String(c.before) : "",
    after: c && c.after != null ? String(c.after) : "",
    widens: !!(c && c.widens),
  }));
}

export function accessCardTitle(card) {
  if (!card) return "";
  if (card._status === "done" && card._result) return `Access rules of ${card.module} changed`;
  if (card._status === "done" || card._status === "error") return "Access change not applied";
  const listing = card.listing ? `the ${card.listing} listing` : "this listing";
  if (card.kind === "listingRemove") return `Remove ${listing}?`;
  if (card.kind === "listing") return `Save ${listing}?`;
  return `Change access in ${card.module}?`;
}
